export const MAIN_API = "https://staging-cms.manaliyo.lk/api";

export const regions = [
  "Ampara",
  "Anuradhapura",
  "Badulla",
  "Batticaloa",
  "Colombo",
  "Galle",
  "Gampaha",
  "Hambantota",
  "Jaffna",
  "Kalutara",
  "Kandy",
  "Kegalle",
  "Kilinochchi",
  "Kurunegala",
  "Mannar",
  "Matale",
  "Matara",
  "Monaragala",
  "Mullaitivu",
  "Nuwara Eliya",
  "Polonnaruwa",
  "Puttalam",
  "Ratnapura",
  "Trincomalee",
  "Vavuniya"
];


export const districts = [
  { label: 'Ampara', value: 'Ampara' },
  { label: 'Anuradhapura', value: 'Anuradhapura' },
  { label: 'Badulla', value: 'Badulla' },
  { label: 'Batticaloa', value: 'Batticaloa' },
  { label: 'Colombo', value: 'Colombo' },
  { label: 'Galle', value: 'Galle' },
  { label: 'Gampaha', value: 'Gampaha' },
  { label: 'Hambantota', value: 'Hambantota' },
  { label: 'Jaffna', value: 'Jaffna' },
  { label: 'Kalutara', value: 'Kalutara' },
  { label: 'Kandy', value: 'Kandy' },
  { label: 'Kegalle', value: 'Kegalle' },
  { label: 'Kilinochchi', value: 'Kilinochchi' },
  { label: 'Kurunegala', value: 'Kurunegala' },
  { label: 'Mannar', value: 'Mannar' },
  { label: 'Matale', value: 'Matale' },
  { label: 'Matara', value: 'Matara' },
  { label: 'Moneragala', value: 'Moneragala' },
  { label: 'Mullaitivu', value: 'Mullaitivu' },
  { label: 'Nuwara Eliya', value: 'Nuwara Eliya' },
  { label: 'Polonnaruwa', value: 'Polonnaruwa' },
  { label: 'Puttalam', value: 'Puttalam' },
  { label: 'Ratnapura', value: 'Ratnapura' },
  { label: 'Trincomalee', value: 'Trincomalee' },
  { label: 'Vavuniya', value: 'Vavuniya' }
];

export const genders = ["male", "female"];

export const Ethnicities = ["Sinhalease", "Tamil", "Musilm"];

export const religions = [
  "Buddhism",
  "Hinduism",
  "Christianity",
  "Islam",
  "Sikhism",
  "Jainism",
  "Bahá'í Faith"
];

export const residencyStatuses = ["Citizen", "Non-resident"];

export const civilStatuses = ["Never Married", "Married", "Widowed"];

export const educationLevels = ["PhD or Doctorate", "Master's Degree", "Bachelor's Degree","Diploma", "Up to GCE O/L", "Up to GCE A/L"];

export const professions = ["Accountant", "Architect"];

export const foodPreferences = ["Non Vegetarian", "Vegetarian", "Vegan"];

export const profileTypes = [
  {
    label: "Own",
    value: "myself",
  },
  {
    label: "By Son",
    value: "myson",
  },
  {
    label: "By Daughter",
    value: "mydaughter",
  },
  {
    label: "By Brother",
    value: "mybrother",
  },
  {
    label: "By Sister",
    value: "mysister",
  },
  {
    label: "By Friend",
    value: "myfriend",
  },
  {
    label: "By Relative",
    value: "myrelative",
  },
];
